import React, { useState, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import Novartis from "~/images/Novartis.png";
import LdnDesignationForm from "./LdnDesignationForm";

const NovartisDesignations = ({ entities, setCompletedDesignations }) => {
  const manufacturer = "novartis";
  const manufacturerName = "Novartis";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] = useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    novartis: {},
  });

  useEffect(() => {
    setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const sharedProps = {
    entities,
    manufacturer,
    manufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
      productName={specialtyKeyName}
    />
  );

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Novartis} style={{ height: 30 }} />
        </div>
        <div className="designation_form__section__header__title">{manufacturerName}</div>
      </div>
      {renderDesignationForm(RetailDesignationForm, "retail")}
      {renderDesignationForm(LdnDesignationForm, "fabhalta")}
      {renderDesignationForm(LdnDesignationForm, "scemblix")}
      {renderDesignationForm(LdnDesignationForm, "vanrafia")}
      {renderDesignationForm(LdnDesignationForm, "vijoice")}
      {renderDesignationForm(LdnDesignationForm, "piqray")}
      {renderDesignationForm(LdnDesignationForm, "kisqali")}
    </div>
  );
};

export default NovartisDesignations;
